/* Wishlist count bubble (header heart + mobile drawer row), 2026-07-16.

   snippets/wl-init.liquid OWNS the /apps/hh/api/wishlist/state request and
   caches { at, gids } in sessionStorage for 5 minutes. This script only
   READS that cache — polling briefly on cold loads so it never fires a
   duplicate request — and listens for the `larden:wishlist` CustomEvent
   that wl-init (and the wishlist page itself) dispatches after every heart
   toggle, so the bubble updates live without a reload. */
(function () {
  var CACHE_KEY = 'larden_wishlist_state';

  function paint(n) {
    var els = document.querySelectorAll('[data-hh-wl-count]');
    for (var i = 0; i < els.length; i++) {
      if (typeof n === 'number' && n > 0) {
        els[i].textContent = n > 99 ? '99+' : String(n);
        els[i].classList.remove('visually-hidden');
      } else {
        els[i].textContent = '';
        els[i].classList.add('visually-hidden');
      }
    }
  }

  function fromCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.gids) {
        paint(c.gids.length);
        return true;
      }
    } catch (e) {
      /* storage blocked → the bubble simply stays hidden */
    }
    return false;
  }

  // Cold load: wl-init's /state response lands within a moment and writes the
  // cache; check a few times instead of racing it with a second request.
  var tries = 0;
  function tick() {
    if (fromCache()) { return; }
    if (++tries < 10) { setTimeout(tick, 400); }
  }

  document.addEventListener('larden:wishlist', function (ev) {
    var d = ev && ev.detail;
    if (d && typeof d.count === 'number') { paint(d.count); }
  });

  if (document.readyState !== 'loading') { tick(); }
  else { document.addEventListener('DOMContentLoaded', tick); }
})();
